export function Spinner({ className = "size-8" }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Chargement"
      className={`inline-block animate-spin rounded-full border-3 border-ink/10 border-t-accent ${className}`}
    />
  );
}

/**
 * What a page shows while its data loads. No text on purpose: a sentence that is replaced
 * a moment later reads as the page jumping, a spinner reads as waiting.
 */
export function PageLoader() {
  return (
    <div className="grid min-h-[60dvh] place-items-center">
      <Spinner />
    </div>
  );
}
